// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `img {
  width: 100%;
  height: 100%;
}`, "",{"version":3,"sources":["webpack://./projects/mydocma/dynamic-form/src/lib/fields/image/image-field/image-field.component.scss","webpack://./../mydocma-dynamic-form-app%20(dev)/projects/mydocma/dynamic-form/src/lib/fields/image/image-field/image-field.component.scss"],"names":[],"mappings":"AAAA;EACI,WAAA;EACA,YAAA;ACCJ","sourcesContent":["img{\r\n    width: 100%;\r\n    height: 100%;\r\n}\r\n","img {\n  width: 100%;\n  height: 100%;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
